import React from 'react';
import {
  ErrorWrapper,
  ErrorHeading,
  ErrorMessage,
  Emoji,
  Button,
} from '../../styles/TwilioVerification.styled';

const TwilioError = ({ setShowTwilioVerification, setVerificationStatus }) => (
  <ErrorWrapper>
    <ErrorHeading>Something went wrong</ErrorHeading>
    <Emoji>&#128557;</Emoji>
    <ErrorMessage>
      The code you entered is not valid. Please resubmit the form.
    </ErrorMessage>
    <Button
      onClick={() => {
        setShowTwilioVerification(false);
        setVerificationStatus('pending');
      }}
    >
      Go back to form
    </Button>
  </ErrorWrapper>
);

export default TwilioError;
